import { render, staticRenderFns } from "./DropZoneFiles.vue?vue&type=template&id=6cff25c6&"
import script from "./DropZoneFiles.vue?vue&type=script&lang=js&"
export * from "./DropZoneFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports